/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextBulletIcon16Light } from './TextBulletIcon16Light';
import { TextBulletIcon16Regular } from './TextBulletIcon16Regular';
import { TextBulletIcon16Solid } from './TextBulletIcon16Solid';
import { TextBulletIcon20Light } from './TextBulletIcon20Light';
import { TextBulletIcon20Regular } from './TextBulletIcon20Regular';
import { TextBulletIcon20Solid } from './TextBulletIcon20Solid';
import { TextBulletIcon24Regular } from './TextBulletIcon24Regular';
import { TextBulletIcon24Solid } from './TextBulletIcon24Solid';
import { TextBulletIcon32Regular } from './TextBulletIcon32Regular';
import { TextBulletIcon64Regular } from './TextBulletIcon64Regular';
var sizes = {
    16: {
        light: TextBulletIcon16Light,
        regular: TextBulletIcon16Regular,
        solid: TextBulletIcon16Solid,
    },
    20: {
        light: TextBulletIcon20Light,
        regular: TextBulletIcon20Regular,
        solid: TextBulletIcon20Solid,
    },
    24: {
        regular: TextBulletIcon24Regular,
        solid: TextBulletIcon24Solid,
    },
    32: {
        regular: TextBulletIcon32Regular,
    },
    64: {
        regular: TextBulletIcon64Regular,
    },
};
export var TextBulletIcon = forwardRef('TextBulletIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
